import { ClipboardCheck, Star } from 'lucide-react'
import { PerformanceReviewSpaceFields } from '@/components/features/performanceReview/PerformanceReviewSpaceFields'
import { apiErrors, reviewSpaceModeOf } from '@/components/features/performanceReview/reviewUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const PerformanceReviewPage = lazyPage(() => import('@/pages/PerformanceReview'), 'PerformanceReviewPage')

export const performanceReviewModule: ModuleDefinition = {
  key: 'performanceReview',
  icon: ClipboardCheck,
  iconName: 'clipboard-check',
  namespaces: ['performanceReview'],
  ready: true,
  ListPage: PerformanceReviewPage,
  /* "One cycle" or "Several cycles" (F-48 criterion 1): short, so it sits on the details step. */
  setup: {
    wizardStep: 'details',
    /* Cycles are made by owner and admin. */
    defaultWhoCanPost: 'admins',
    defaultConfig: () => ({ mode: 'multi' }),
    validate: () => null,
    /* "One cycle" on a space with two or more: 409 on `moduleConfig.mode`, the message under the choice. */
    errorsFromApi: (err) => {
      const hit = apiErrors(err).find((e) => e.param === 'moduleConfig.mode' || e.param === 'mode')
      return hit?.message ? { mode: hit.message } : null
    },
    Fields: PerformanceReviewSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), mode: config?.mode === 'single' ? 'single' : 'multi' }),
      fromSpace: (space) => ({ mode: reviewSpaceModeOf(space.moduleConfig) })
    }
  },
  posting: false,
  /* A one-cycle space is born with its cycle (create wizard); the edit dialog has no follow-up for it. */
  singleItem: {},
  workflow: { trigger: { block: 'reviews', icon: Star, hrPrefixes: ['review.', 'time.review_'] } }
}
